module.exports = __webpack_public_path__ + "img/trash.e91b0584.svg";